import React from 'react';

const LeagueComp = ({ league, handleTeamClick }) => (

  <div className="teams__league">
    <div className="teams__league-txt">{league?.name}</div>

    <ul className="teams__league-list">
      {league?.competitors.map((team) => (
        <li
          className={`teams__league-item ${team?.squadCompleted ? 'is-set' : 'is-unset'}`}
          key={team?.id}
          onClick={handleTeamClick.bind(this, league?.id, team?.id, team?.squadCompleted)}
        >
          <span>{team?.name}</span>
        </li>

      ))}
    </ul>

  </div>
);

export default LeagueComp;
